import { isArray } from 'lodash';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import useSmartCalendar from './useSmartCalendar';

export default function useURLDate() {
  const [date, setDate] = useState<string | undefined>();

  const router = useRouter();
  const { selectedDate } = router.query;
  const { setDate: setDateGlobally } = useSmartCalendar();

  const urlDate = isArray(selectedDate) ? selectedDate[0] : selectedDate;

  useEffect(() => {
    if (urlDate) {
      setDate(urlDate);
      setDateGlobally(new Date(urlDate));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [urlDate]);

  return date;
}
